import React, { HTMLAttributes } from 'react';
import {
    FieldError,
    UseFormRegister,
    Path,
    FieldValues,
} from 'react-hook-form';
import { Input } from '../ui/input';
import { cn } from '@/lib/utils'; 
import { IoAlertCircleOutline } from 'react-icons/io5';

interface FormFieldProps<TFormData extends FieldValues> {
    type: string;
    placeholder?: string;
    name: Path<TFormData>;
    register: UseFormRegister<TFormData>;
    error?: FieldError | undefined;
    valueAsNumber?: boolean;
    label?: string;
    style?: string;
    value?: string | null;
    styleInput?: string | null;
    inputmode?: HTMLAttributes<string>['inputMode'];
    maxLenth?: string;
    autoFocus?: boolean;
    labelStyle?: string;
    errorStyle?: string;
    dir?: 'rtl' | 'ltr';
}

const CustomFieldInput = <TFormData extends FieldValues>({
    type,
    placeholder,
    name,
    register,
    error,
    valueAsNumber,
    label,
    style,
    styleInput,
    inputmode,
    maxLenth,
    autoFocus,
    labelStyle,
    errorStyle,
    dir,
}: FormFieldProps<TFormData>) => {
    return (
        <div className={style}>
            <label
                className={`${labelStyle} text-[11px] border-0 bg-white md:text-xs text-lime-800`}
                htmlFor={String(name)}
            >
                {label}
            </label>
            <Input
                className={cn(
                    'input_login placeholder:text-gray-400 placeholder:text-sm w-full  focus:ring-2 focus:ring-[#8e29ea]',
                    styleInput,
                )}
                dir={dir}
                type={type}
                placeholder={placeholder}
                {...register(name, { valueAsNumber })}
                autoComplete="off"
                inputMode={inputmode}
                max={maxLenth}
                autoFocus={autoFocus}
            />
            {error?.message && (
                <span
                    className={`${
                        errorStyle ? errorStyle : ''
                    } text-xs text-red-400 pt-2`}
                >
                    <IoAlertCircleOutline className="inline mr-1" />{' '}
                    {error?.message}
                </span>
            )}
        </div>
    );
};

export default CustomFieldInput;
